export const handleDownload = (image: string | null) => {
  if (!image) {
    console.error("Image URL not found");
    return;
  }

  // Get the current date and time
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // months are 0-indexed in JS
  const date = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  const second = String(now.getSeconds()).padStart(2, "0");

  // Create a link element
  const link = document.createElement("a");
  
  // Check if the image is already a data URL
  if (image.startsWith('data:')) {
    // It's already a data URL, use it directly
    link.href = image;
  } else {
    // It's a regular URL, fetch it and convert to blob
    fetch(image)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = `senf_generatedImage_${year}${month}${date}_${hour}${minute}${second}.jpg`;
        link.click();
        
        // Revoke the Blob URL after the link is clicked to free up resources
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 100);
      })
      .catch(error => {
        console.error("Error downloading image:", error);
      });
    
    return; // Exit early as we're handling the download asynchronously
  }
  
  // For data URLs, proceed with the download
  link.download = `senf_generatedImage_${year}${month}${date}_${hour}${minute}${second}.jpg`;
  link.click();
};
